import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* eslint-disable */
/**
 * Misc
 * Miscellaneous utilities and test-only endpoints
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/misc.yaml
// Template file: apiServices.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { AbInternalConfigurationFactory } from "../dto/AbInternalConfiguration";
// @ts-ignore noUnusedLocals
import { AbVersionInfoFactory } from "absdk/commons/api/dto/AbVersionInfo";
import { AbWebServices } from "abweb/service/AbWebServices";
import { LogUtils } from "abweb/utils/log/LogUtils";
import { StringUtils } from "abweb/utils/StringUtils";
import { URLUtils } from "abweb/utils/URLUtils";
// @ts-ignore noUnusedLocals

// @ts-ignore noUnusedLocals

export class AbInternalMiscApiServices {
  static initDefaultServices() {
    AbInternalMiscApiServices.buildApiService(AbWebServices.getRPCService(), "", true, true);
  }
  static buildApiService(rpcService, proxyLabel, isDefault, isLocal = false) {
    if (AbInternalMiscApiServices.serviceMap.has(proxyLabel)) {
      AbInternalMiscApiServices.LOG.warn("Already initialized AbInternalMiscApiServices. Call resetServices before re-initializing.");
    }
    proxyLabel = StringUtils.emptyIfNull(proxyLabel);
    const abInternalMiscApi = new AbInternalMiscApiInvoker(rpcService);
    AbInternalMiscApiServices.serviceMap.set(proxyLabel, abInternalMiscApi);

    // If the service is considered "default" and the proxyLabel is not "" you would
    // usually also set it as the service identified by the empty label. However,
    // we know that it is possible that an application may want to host non-proxied services
    // in addition to proxied ones. In that case, DO NOT clear out the native service
    // that is already stored with the empty label.
    if (isLocal || isDefault && proxyLabel !== "" && AbInternalMiscApiServices.serviceMap.get("") == null) {
      AbInternalMiscApiServices.serviceMap.set("", abInternalMiscApi);
    }
    return abInternalMiscApi;
  }
  static getAbInternalMiscApi(proxyLabel) {
    proxyLabel = StringUtils.emptyIfNull2(proxyLabel);
    let services = AbInternalMiscApiServices.serviceMap.get(proxyLabel);
    if (!services) {
      services = AbInternalMiscApiServices.serviceMap.get(proxyLabel);
      if (!services) {
        throw new Error(`No proxy service found for proxy label '${proxyLabel}'`);
      }
    }
    return services;
  }
  static resetServices() {
    AbInternalMiscApiServices.serviceMap.clear();
  }
}
_defineProperty(AbInternalMiscApiServices, "LOG", LogUtils.getLogger("AbInternalMiscApiServices"));
_defineProperty(AbInternalMiscApiServices, "serviceMap", new Map());
class AbInternalMiscApiInvoker {
  constructor(rpcService) {
    _defineProperty(this, "rpcService", void 0);
    this.rpcService = rpcService;
  }
  async getConfiguration() {
    const parameters = {};
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/abweb/misc/configuration", parameters);
    const response = await this.rpcService.invokeRetJSON(invokeUrl, null, {
      method: "GET".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
    let responseObject = AbInternalConfigurationFactory.FromJSON(response);
    return responseObject;
  }
  async getVersionInfo() {
    const parameters = {};
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/abweb/misc/version", parameters);
    const response = await this.rpcService.invokeRetJSON(invokeUrl, null, {
      method: "GET".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
    let responseObject = AbVersionInfoFactory.FromJSON(response);
    return responseObject;
  }
  async reloadConfiguration() {
    const parameters = {};
    const contentType = "application/json";
    let invokeUrl = URLUtils.addParamsToUrl("/api/abweb/misc/configuration/action/reload", parameters);
    await this.rpcService.invokeVoid(invokeUrl, null, {
      method: "POST".toLowerCase(),
      headers: {
        "Content-Type": contentType
      }
    });
  }
}
//# sourceMappingURL=AbInternalMiscApiServices.js.map
